<template>
  <div class="comment-search-container mb-4">
    <label for="search">Search questions & reviews</label>
    <div class="d-flex">
      <!-- eslint-disable vue-a11y/form-has-label -->
      <input
        id="search"
        v-model="searchTerm"
        type="text"
        placeholder="Keyword"
        class="form-control search-input"
        :disabled="isFetching"
        @keyup.enter="onSubmit"
      >
      <!-- eslint-enable vue-a11y/form-has-label -->
      <button
        class="btn btn-secondary ml-3"
        type="button"
        :disabled="isFetching"
        @click="onSubmit"
        @keydown.enter="onSubmit"
      >
        <span>Search</span>
      </button>
    </div>
    <div
      v-if="showResults"
      class="row"
    >
      <div class="col-12 mt-3 results-info">
        <em>
          Viewing {{ searchAmount }} total results for "{{ currentSearchTerm }}":
        </em>
        <button
          class="clear-button btn btn-link px-2"
          @click="onClear"
          @keydown.enter="onClear"
        >
          Clear filter
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PDPSearch',
  data() {
    return {
      searchTerm: '',
      showResults: false,
      currentSearchTerm: '',
    };
  },
  computed: {
    searchAmount() {
      return this.$store.getters['discussion/searchAmount'];
    },
    isFetching() {
      return this.$store.getters['discussion/isFetching'];
    },
  },
  methods: {
    onClear() {
      this.showResults = false;
      this.searchTerm = '';
      this.currentSearchTerm = '';
      this.$store.dispatch('discussion/setSerchTerm', '');
    },
    onSubmit() {
      if (this.searchTerm) {
        this.showResults = true;
        this.currentSearchTerm = this.searchTerm;
        this.$store.dispatch('discussion/setSerchTerm', this.currentSearchTerm);

        return;
      }

      if (this.currentSearchTerm) {
        this.onClear();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .search-input {
    border-radius: 3px;
    border: 1px solid #ddd;
    line-height: 1;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);

    &:focus {
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      border: 1px solid #0275d8 !important;
      padding-left: 1rem !important;
    }
  }

  .btn-secondary {
    font-weight: 600;
    border: 2px solid transparent;
    border-color: #0275d8;
    background-color: #0275d8;
    color: #fff;
  }

  .btn-secondary:hover,
  .btn-secondary:active,
  .btn-secondary:focus {
    background-color: #0260b2;
    border-color: #025aa5;
    color: #fff;
  }

  h3 {
    font-size: 1.25rem;
    font-weight: 700;
  }

  .results-info {
    font-size: 0.9rem;

    .clear-button {
      color: #0275d8 !important;
      font-size: 0.9rem;
      font-weight: 600;

      &:hover {
        color: #0260b2 !important;
      }
    }

    i {
      font-weight: 300;
    }
  }
</style>
